module.exports = __webpack_public_path__ + "static/media/fondo2.8b5fc660.png";